"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const valueIsString_1 = __importDefault(require("./valueIsString"));
const valueIsShapeAssertion_1 = __importDefault(require("./valueIsShapeAssertion"));
const valueIsUndefined_1 = __importDefault(require("./valueIsUndefined"));
const valueIsOneOfAssertions_1 = __importDefault(require("./valueIsOneOfAssertions"));
const valueIsBoolean_1 = __importDefault(require("./valueIsBoolean"));
const valueIsControlCalendarMarkedDate = (0, valueIsShapeAssertion_1.default)({
    date: valueIsString_1.default,
    marked: (0, valueIsOneOfAssertions_1.default)([
        valueIsUndefined_1.default,
        valueIsBoolean_1.default,
    ]),
    selected: (0, valueIsOneOfAssertions_1.default)([
        valueIsUndefined_1.default,
        valueIsBoolean_1.default,
    ]),
    disabled: (0, valueIsOneOfAssertions_1.default)([
        valueIsUndefined_1.default,
        valueIsBoolean_1.default,
    ]),
    disableTouchEvent: (0, valueIsOneOfAssertions_1.default)([
        valueIsUndefined_1.default,
        valueIsBoolean_1.default,
    ]),
    startingDay: (0, valueIsOneOfAssertions_1.default)([
        valueIsUndefined_1.default,
        valueIsBoolean_1.default,
    ]),
    endingDay: (0, valueIsOneOfAssertions_1.default)([
        valueIsUndefined_1.default,
        valueIsBoolean_1.default,
    ]),
    color: (0, valueIsOneOfAssertions_1.default)([
        valueIsUndefined_1.default,
        valueIsString_1.default,
    ]),
    textColor: (0, valueIsOneOfAssertions_1.default)([
        valueIsUndefined_1.default,
        valueIsString_1.default,
    ]),
    selectedColor: (0, valueIsOneOfAssertions_1.default)([
        valueIsUndefined_1.default,
        valueIsString_1.default,
    ]),
    dotColor: (0, valueIsOneOfAssertions_1.default)([
        valueIsUndefined_1.default,
        valueIsString_1.default,
    ]),
});
exports.default = valueIsControlCalendarMarkedDate;
